import { Chip } from "@mui/material";
import { colors, spacing } from "../../../../assets/styles/tokens";
import StatusChip from "../StatusChip";

// Mobile-only variant of the shared StatusChip — kept separate rather than
// restyling that component, since these design-token colors and the
// no-icon treatment are specific to the mobile card and shouldn't change
// the desktop LeadsTable/LeadDetailDrawer chips (which keep their own
// icon + color per STATUS_ICON_META in StatusChip.tsx).
const MOBILE_STATUS_META: Record<string, { color: string; bg: string }> = {
  Success: { color: colors.Success[600].$value, bg: colors.Success[50].$value },
  Qualified: { color: colors.Success[600].$value, bg: colors.Success[50].$value },
  "Not Qualified": { color: colors.Error[600].$value, bg: colors.Error[50].$value },
  Failure: { color: colors.Error[600].$value, bg: colors.Error[50].$value },
  Rejected: { color: colors.Error[600].$value, bg: colors.Error[50].$value },
  "Brand Duplication": { color: colors.Warning[600].$value, bg: colors.Warning[50].$value },
  "Duplicate Email": { color: colors.Warning[600].$value, bg: colors.Warning[50].$value },
  "Duplicate IP": { color: colors.Warning[600].$value, bg: colors.Warning[50].$value },
  Pending: { color: colors.GrayLightMode[500].$value, bg: colors.GrayLightMode[200].$value },
  Logged: { color: colors.GrayLightMode[700].$value, bg: colors.GrayLightMode[200].$value },
  Initial: { color: colors.GrayLightMode[500].$value, bg: colors.GrayLightMode[200].$value },
  "Not Supported": { color: colors.Error[600].$value, bg: colors.Error[50].$value },
};

const mobileChipSx = (color: string, bg: string) => ({
  height: "20px",
  color,
  bgcolor: bg,
  border: "none",
  borderRadius: spacing.Radius.sm.$value,
  "& .MuiChip-label": {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "10px",
    lineHeight: "14px",
    letterSpacing: "0%",
    verticalAlign: "middle",
  },
});

export default function LeadsMobileStatusChip({ label }: { label: string }) {
  const meta = MOBILE_STATUS_META[label];
  // Every status StatusChip knows is listed above; this fallback only
  // catches an unexpected label, which then renders the desktop chip.
  if (!meta) return <StatusChip label={label} desktopLabel={false} />;
  return <Chip label={label} size="small" sx={mobileChipSx(meta.color, meta.bg)} />;
}

// Mobile Report Log brand chip — same shape as the status chip beside it,
// in bg-brand-primary (Brand-50) / text-brand-secondary (Brand-700).
export function LeadsMobileBrandChip({ brand }: { brand: string }) {
  if (!brand) return null;
  return <Chip label={brand} size="small" sx={mobileChipSx(colors.Brand[700].$value, colors.Brand[50].$value)} />;
}
